import { ROUTES_NAMES } from 'constants/servicenow.routes'
import { Mock } from 'types/global'

export const mockNotificationResult = () => ({
    result: [
      {
        "incident_type": {
          "display_value": "Falha na cadeia medicamentosa",
          "value": "falha_na_cadeia_medicamentosa"
        },
        "involves_patient": {
          "display_value": "verdadeiro",
          "value": "true"
        },
        "u_attachments_presigned_url": {
          "display_value": "",
          "value": ""
        },
        "u_number_patients_involved": {
          "display_value": "1 paciente",
          "value": "um_paciente"
        },
        "incident_description": {
          "display_value": "Prescrevo bloqueio analgesico e não adminsitrado por 2 dias seguidos (01 e 02/01), adminsitrado apenas dia 03/01.",
          "value": "Prescrevo bloqueio analgesico e não adminsitrado por 2 dias seguidos (01 e 02/01), adminsitrado apenas dia 03/01."
        },
        "reporter_name": {
          "display_value": "",
          "value": ""
        },
        "sys_updated_on": {
          "display_value": "14/01/2025 11:14:36",
          "value": "2025-01-14 14:14:36"
        },
        "u_notification_creation_month": {
          "display_value": "1",
          "value": "1"
        },
        "incident_sector": {
          "display_value": "UTI - Unidade de Terapia Intensiva / Adulto",
          "value": "220237541bc1f114d83e0dcbe54bcb15"
        },
        "u_attachments_string": {
          "display_value": "",
          "value": ""
        },
        "number": {
          "display_value": "HISVJ9T4YDJFU",
          "value": "HISVJ9T4YDJFU"
        },
        "incident_title": {
          "display_value": "Medicação não administrada",
          "value": "Medicação não administrada"
        },
        "sys_updated_by": {
          "display_value": "notifica.admin",
          "value": "notifica.admin"
        },
        "u_attachments_size": {
          "display_value": "",
          "value": ""
        },
        "u_disclosure_comments": {
          "display_value": "",
          "value": ""
        },
        "u_never_events": {
          "display_value": "",
          "value": ""
        },
        "sys_created_on": {
          "display_value": "04/01/2025 15:06:49",
          "value": "2025-01-04 18:06:49"
        },
        "u_oms_classification": {
          "display_value": "Procedimento/Processo Clínico",
          "value": "procedimento_processo_clinico"
        },
        "u_observation_incident_classification": {
          "display_value": "",
          "value": ""
        },
        "u_certifier_accreditor_protocol": {
          "display_value": "",
          "value": ""
        },
        "sys_created_by": {
          "display_value": "notifica.admin",
          "value": "notifica.admin"
        },
        "u_notifica_user": {
          "display_value": "jean.jesus@rededor.com.br",
          "value": "jean.jesus@rededor.com.br"
        },
        "u_attachments_url": {
          "display_value": "",
          "value": ""
        },
        "u_notification_creation_year": {
          "display_value": "2025",
          "value": "2025"
        },
        "u_probability_occurence": {
          "display_value": 1,
          "value": 1
        },
        "document_number": {
          "display_value": "44148909",
          "value": "44148909"
        },
        "u_attachments": {
          "display_value": "",
          "value": ""
        },
        "u_state": {
          "display_value": "Aguardando",
          "value": "2"
        },
        "u_date_and_hour_notification_closed": {
          "display_value": "",
          "value": ""
        },
        "u_image_risk": {
          "display_value": "Não",
          "value": "u_image_risk_no"
        },
        "u_note_external_notification": {
          "display_value": "",
          "value": ""
        },
        "u_managers_review": {
          "display_value": "",
          "value": ""
        },
        "contributing_mitigating_factors": {
          "display_value": "",
          "value": ""
        },
        "work_notes": {
          "display_value": "",
          "value": ""
        },
        "immediate_corrective_action": {
          "display_value": "Prescrevo novamente",
          "value": "Prescrevo novamente"
        },
        "notification_type": {
          "display_value": "Anônimo",
          "value": "anonymous"
        },
        "u_date_and_time_closed_by_manager": {
          "display_value": "",
          "value": ""
        },
        "u_reason_for_archiving": {
          "display_value": null,
          "value": ""
        },
        "location_incident": {
          "display_value": "SP - Hospital São Luiz Jabaquara",
          "value": "2f5ab5fe1bfa7810bcd687bfe54bcbcc"
        },
        "u_reclassified_incident_type": {
          "display_value": "Falha na administração do medicamento",
          "value": "falha_na_administracao_do_medicamento"
        },
        "patient_date_of_birth": {
          "display_value": "31/10/1970",
          "value": "1970-10-31"
        },
        "u_attachments_html": {
          "display_value": null,
          "value": ""
        },
        "sys_class_name": {
          "display_value": "Hospital Incidents",
          "value": "x_rdsls_notificabe_hospital_incidents"
        },
        "u_archiving_observations": {
          "display_value": "",
          "value": ""
        },
        "u_incident_classification": {
          "display_value": null,
          "value": ""
        },
        "sys_id": {
          "display_value": "0ff7eb073bb6565496633447f4e45a58",
          "value": "0ff7eb073bb6565496633447f4e45a58"
        },
        "reporter_sector": {
          "display_value": "UTI - Unidade de Terapia Intensiva / Adulto",
          "value": "220237541bc1f114d83e0dcbe54bcb15"
        },
        "shift_incident": {
          "display_value": "Diurno (7h - 18h59)",
          "value": "daytime"
        },
        "damage_level": {
          "display_value": "Dano leve",
          "value": "6e37039cdb76a110839481640496191f"
        },
        "u_sub_damage_level": {
            "display_value": "",
            "value": ""
        },
        "document_type": {
          "display_value": "Atendimento",
          "value": "atendimento"
        },
        "u_assigned_to": {
          "display_value": "",
          "value": ""
        },
        "u_treatment_by": {
          "display_value": "",
          "value": ""
        },
        "forwarded_by": {
          "display_value": "Thamara Cristina Petrella Saweljew",
          "value": "23dcf0edfb01d2901bfff8d65eefdce9"
        },
        "patient_gender": {
          "display_value": "Masculino",
          "value": "masculino"
        },
        "sys_mod_count": {
          "display_value": "5",
          "value": "5"
        },
        "u_disclosure": {
          "display_value": null,
          "value": ""
        },
        "patient_initials": {
          "display_value": "A.N.P",
          "value": "A.N.P"
        },
        "u_notification_multiplier": {
          "display_value": "1",
          "value": "1"
        },
        "sys_tags": {
          "display_value": "",
          "value": ""
        },
        "date_incident": {
          "display_value": "03/01/2025",
          "value": "2025-01-03"
        },
        "u_notification_read": {
          "display_value": "verdadeiro",
          "value": "true"
        },
        "u_notification_comments": {
          "display_value": "",
          "value": ""
        },
        "u_categorized_contributing_factor": {
          "display_value": "Tecnologia e sistemas eletrônicos de informação",
          "value": "technology_and_electronic_information_systems"
        },
        "mitigating_factors": {
          "display_value": "",
          "value": ""
        },
        "u_reviewed_by": {
          "display_value": "",
          "value": ""
        }
      },
      {
        "incident_type": {
          "display_value": "Atraso na entrega medicamento",
          "value": "atraso_na_entrega_medicamento"
        },
        "involves_patient": {
          "display_value": "verdadeiro",
          "value": "true"
        },
        "u_attachments_presigned_url": {
          "display_value": "",
          "value": ""
        },
        "u_number_patients_involved": {
          "display_value": "1 paciente",
          "value": "um_paciente"
        },
        "incident_description": {
          "display_value": "Lorazepan do horário das 14h entregue no setor às 15hs",
          "value": "Lorazepan do horário das 14h entregue no setor às 15hs"
        },
        "reporter_name": {
          "display_value": "",
          "value": ""
        },
        "sys_updated_on": {
          "display_value": "04/01/2025 14:56:05",
          "value": "2025-01-04 17:56:05"
        },
        "u_notification_creation_month": {
          "display_value": "1",
          "value": "1"
        },
        "incident_sector": {
          "display_value": "Farmácia",
          "value": "60e07fd81b81f114d83e0dcbe54bcbff"
        },
        "u_attachments_string": {
          "display_value": "",
          "value": ""
        },
        "number": {
          "display_value": "HISPZRYF81EZI",
          "value": "HISPZRYF81EZI"
        },
        "incident_title": {
          "display_value": "Medicação",
          "value": "Medicação"
        },
        "sys_updated_by": {
          "display_value": "notifica.admin",
          "value": "notifica.admin"
        },
        "u_attachments_size": {
          "display_value": "",
          "value": ""
        },
        "u_disclosure_comments": {
          "display_value": "",
          "value": ""
        },
        "u_never_events": {
          "display_value": "",
          "value": ""
        },
        "sys_created_on": {
          "display_value": "04/01/2025 14:54:36",
          "value": "2025-01-04 17:54:36"
        },
        "u_oms_classification": {
          "display_value": "Gerenciamento de recursos/organizacional",
          "value": "gerenciamento_de_recursos_organizacional"
        },
        "u_observation_incident_classification": {
          "display_value": "",
          "value": ""
        },
        "u_certifier_accreditor_protocol": {
          "display_value": "",
          "value": ""
        },
        "sys_created_by": {
          "display_value": "notifica.admin",
          "value": "notifica.admin"
        },
        "u_notifica_user": {
          "display_value": "thamara.petrella@hospitalbrasil.com.br",
          "value": "thamara.petrella@hospitalbrasil.com.br"
        },
        "u_attachments_url": {
          "display_value": "",
          "value": ""
        },
        "u_notification_creation_year": {
          "display_value": "2025",
          "value": "2025"
        },
        "u_probability_occurence": {
          "display_value": 3,
          "value": 3
        
        },
        "document_number": {
          "display_value": "44303660",
          "value": "44303660"
        },
        "u_attachments": {
          "display_value": "",
          "value": ""
        },
        "u_state": {
          "display_value": "Aguardando",
          "value": "2"
        },
        "u_date_and_hour_notification_closed": {
          "display_value": "",
          "value": ""
        },
        "u_image_risk": {
          "display_value": "Não",
          "value": "u_image_risk_no"
        },
        "u_note_external_notification": {
          "display_value": "",
          "value": ""
        },
        "u_managers_review": {
          "display_value": "",
          "value": ""
        },
        "contributing_mitigating_factors": {
          "display_value": "",
          "value": ""
        },
        "work_notes": {
          "display_value": "",
          "value": ""
        },
        "immediate_corrective_action": {
          "display_value": "Farmacia alega entrega de medicação com 5 horas de antecedencia e não entrega nem com 1 hora",
          "value": "Farmacia alega entrega de medicação com 5 horas de antecedencia e não entrega nem com 1 hora"
        },
        "notification_type": {
          "display_value": "Anônimo",
          "value": "anonymous"
        },
        "u_date_and_time_closed_by_manager": {
          "display_value": "",
          "value": ""
        },
        "u_reason_for_archiving": {
          "display_value": null,
          "value": ""
        },
        "location_incident": {
          "display_value": "SP - Hospital São Luiz Jabaquara",
          "value": "2f5ab5fe1bfa7810bcd687bfe54bcbcc"
        },
        "u_reclassified_incident_type": {
          "display_value": "Atraso/falha no abastecimento do arsenal/almoxarifado",
          "value": "atraso_falha_no_abastecimento_do_arsenal_almoxarifado"
        },
        "patient_date_of_birth": {
          "display_value": "24/11/1977",
          "value": "1977-11-24"
        },
        "u_attachments_html": {
          "display_value": null,
          "value": ""
        },
        "sys_class_name": {
          "display_value": "Hospital Incidents",
          "value": "x_rdsls_notificabe_hospital_incidents"
        },
        "u_archiving_observations": {
          "display_value": "",
          "value": ""
        },
        "u_incident_classification": {
          "display_value": null,
          "value": ""
        },
        "sys_id": {
          "display_value": "3f25a74f3bf6565494dd6137f4e45a11",
          "value": "3f25a74f3bf6565494dd6137f4e45a11"
        },
        "reporter_sector": {
          "display_value": "UTI - Unidade de Terapia Intensiva / Adulto",
          "value": "220237541bc1f114d83e0dcbe54bcb15"
        },
        "shift_incident": {
          "display_value": "Diurno (7h - 18h59)",
          "value": "daytime"
        },
        "damage_level": {
          "display_value": "Circunstância notificável",
          "value": "19d0c798db76a1108394816404961944"
        },
        "u_sub_damage_level": {
          "display_value": "",
          "value": ""
        },
        "document_type": {
          "display_value": "Atendimento",
          "value": "atendimento"
        },
        "u_assigned_to": {
          "display_value": "",
          "value": ""
        },
        "u_treatment_by": {
          "display_value": "",
          "value": ""
        },
        "forwarded_by": {
          "display_value": "Thamara Cristina Petrella Saweljew",
          "value": "23dcf0edfb01d2901bfff8d65eefdce9"
        },
        "patient_gender": {
          "display_value": "Masculino",
          "value": "masculino"
        },
        "sys_mod_count": {
          "display_value": "3",
          "value": "3"
        },
        "u_disclosure": {
          "display_value": null,
          "value": ""
        },
        "patient_initials": {
          "display_value": "G.L.D",
          "value": "G.L.D"
        },
        "u_notification_multiplier": {
          "display_value": "1",
          "value": "1"
        },
        "sys_tags": {
          "display_value": "",
          "value": ""
        },
        "date_incident": {
          "display_value": "04/01/2025",
          "value": "2025-01-04"
        },
        "u_notification_read": {
          "display_value": "verdadeiro",
          "value": "true"
        },
        "u_notification_comments": {
          "display_value": "",
          "value": ""
        },
        "u_categorized_contributing_factor": {
          "display_value": "Tecnologia e sistemas eletrônicos de informação",
          "value": "fatores_da_tarefa_e_da_tecnologia"
        },
        "mitigating_factors": {
          "display_value": "",
          "value": ""
        },
        "u_reviewed_by": {
          "display_value": "",
          "value": ""
        }
      }
    ]
  })

export const MocksNotificationServiceNow:Mock[] = [ 
    { 
        'url': ROUTES_NAMES.notification.get.render(), 
        'method': 'GET', 
        'data': {
            "navbar": [
              {
                "id": 1,
                "name": "Novas",
                "unread": "163",
                "number": "170",
                "total": "0"
              },
              {
                "id": 2,
                "name": "Aguardando",
                "number": "2159",
                "total": "0"
              },
              {
                "id": 3,
                "name": "Em tratamento",
                "number": "207",
                "total": "0"
              },
              {
                "id": 4,
                "name": "Pendentes",
                "number": "0",
                "total": "0"
              },
              {
                "id": 5,
                "name": "Finalizada",
                "number": "1079",
                "total": "0"
              },
              {
                "id": 6,
                "name": "Arquivada",
                "number": "141",
                "total": "0"
              },
              {
                "id": 7,
                "name": "Minhas notificações",
                "number": "0",
                "total": "0"
              },
              {
                "id": 8,
                "name": "Todas",
                "number": "3756",
                "total": "0"
              }
            ],
            "select_location": {
              "enabled": true
            },
            "select_sector": {
              "enabled": true
            }
        }
    },
    { 
        'url': ROUTES_NAMES.notification.get.damage_level, 
        'method': 'GET', 
        'data': [
            {
              "id": "fa57f3dc1bb2e11060d9426fe54bcb83",
              "color": "#C43B51",
              "value": "obito",
              "label": "Óbito"
            },
            {
              "id": "5b180b9cdb76a1108394816404961964",
              "color": "#DF8D2C",
              "value": "grave",
              "label": "Grave"
            },
            {
              "id": "cbd08798db76a11083948164049619e2",
              "color": "#8AA15C",
              "value": "moderado",
              "label": "Moderado"
            },
            {
              "id": "6e37039cdb76a110839481640496191f",
              "color": "#6190A4",
              "value": "leve",
              "label": "Leve"
            },
            {
              "id": "62270310dbb6a1108394816404961970",
              "color": "#517BBB",
              "value": "sem-dano",
              "label": "Sem dano"
            },
            {
              "id": "0bd6cbdcdb76a110839481640496192f",
              "color": "#474747",
              "value": "near-miss",
              "label": "Near Miss / Quase erro"
            },
            {
              "id": "19d0c798db76a1108394816404961944",
              "color": "#474747",
              "value": "notifiable",
              "label": "Circunstância notificável"
            }
          ]
    },
    { 
        'url': ROUTES_NAMES.notification.get.all_paginate({ offset : '0', limit:'10', state: 1 }), 
        'method': 'GET', 
        'data': {
            "result": [
                {
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "incident_type": {
                        "display_value": "Queda do paciente",
                        "value": "queda_do_paciente"
                    },
                    "involves_patient": {
                        "display_value": "Verdadeiro",
                        "value": "true"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hosp SL - São Caetano do Sul",
                        "value": "235ab5fe1bfa7810bcd687bfe54bcbf8"
                    },
                    "incident_description": {
                        "display_value": "{Fluxo de teste de validação card} - 20.11.2023",
                        "value": "{Fluxo de teste de validação card} - 20.11.2023"
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "20/11/2023 11:56:01",
                        "value": "2023-11-20 14:56:01"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": "Queda do paciente",
                        "value": "queda_do_paciente"
                    },
                    "patient_date_of_birth": {
                        "display_value": "01/01/1984",
                        "value": "1984-01-01"
                    },
                    "incident_sector": {
                        "display_value": "Ambulatório",
                        "value": "06864af31bb871909cac32681b4bcbeb"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISAVY23HENJC",
                        "value": "HISAVY23HENJC"
                    },
                    "sys_id": {
                        "display_value": "26c612721bae7110081287bfe54bcb68",
                        "value": "26c612721bae7110081287bfe54bcb68"
                    },
                    "incident_title": {
                        "display_value": "{Fluxo de teste de validação card} - 20.11.2023",
                        "value": "{Fluxo de teste de validação card} - 20.11.2023"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "20/11/2023 11:55:37",
                        "value": "2023-11-20 14:55:37"
                    },
                    "u_oms_classification": {
                        "display_value": "Acidente com o paciente",
                        "value": "acidente_com_o_paciente"
                    },
                    "reporter_sector": {
                        "display_value": "Almoxarifado",
                        "value": "8cf0bfd81b81f114d83e0dcbe54bcbd0"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Dano grave",
                        "value": "5b180b9cdb76a1108394816404961964"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": "Atendimento",
                        "value": "atendimento"
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": "Feminino",
                        "value": "feminino"
                    },
                    "damage_level.duration_secs": {
                        "display_value": "259200",
                        "value": "259200"
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "147852369",
                        "value": "147852369"
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "2",
                        "value": "2"
                    },
                    "patient_initials": {
                        "display_value": "G.O.C",
                        "value": "G.O.C"
                    },
                    "date_incident": {
                        "display_value": "20/11/2023",
                        "value": "2023-11-20"
                    },
                    "u_notification_read": {
                        "display_value": "Verdadeiro",
                        "value": "true"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "{Fluxo de teste de validação card} - 20.11.2023",
                        "value": "{Fluxo de teste de validação card} - 20.11.2023"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "notification_type": {
                        "display_value": "Identificado",
                        "value": "identified"
                    },
                    "incident_type": {
                        "display_value": "Outro",
                        "value": "outro"
                    },
                    "involves_patient": {
                        "display_value": "Verdadeiro",
                        "value": "true"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "RJ - Clínica São Vicente",
                        "value": "5b5ab5fe1bfa7810bcd687bfe54bcb27"
                    },
                    "incident_description": {
                        "display_value": "PACIENTE DEU ENTRADA NO SETOR COM UMA CICATRIZ DE LESÃO  EM  REGIÃO SACRA ",
                        "value": "PACIENTE DEU ENTRADA NO SETOR COM UMA CICATRIZ DE LESÃO  EM  REGIÃO SACRA "
                    },
                    "reporter_name": {
                        "display_value": "Pamella Luiza Dias Bastos",
                        "value": "Pamella Luiza Dias Bastos"
                    },
                    "sys_updated_on": {
                        "display_value": "18/11/2023 21:29:18",
                        "value": "2023-11-19 00:29:18"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "28/04/1934",
                        "value": "1934-04-28"
                    },
                    "incident_sector": {
                        "display_value": "UTI - Unidade de Terapia Intensiva / Adulto",
                        "value": "220237541bc1f114d83e0dcbe54bcb15"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISGFARYYKPKN",
                        "value": "HISGFARYYKPKN"
                    },
                    "sys_id": {
                        "display_value": "32e6829a1b2e3d109cac32681b4bcbd1",
                        "value": "32e6829a1b2e3d109cac32681b4bcbd1"
                    },
                    "incident_title": {
                        "display_value": "LESÃO DOMICILIAR",
                        "value": "LESÃO DOMICILIAR"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "18/11/2023 21:29:18",
                        "value": "2023-11-19 00:29:18"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "reporter_sector": {
                        "display_value": "UTI - Unidade de Terapia Intensiva / Adulto",
                        "value": "220237541bc1f114d83e0dcbe54bcb15"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": "Prontuário",
                        "value": "prontuario"
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": "Feminino",
                        "value": "feminino"
                    },
                    "damage_level.duration_secs": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "43239",
                        "value": "43239"
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "patient_initials": {
                        "display_value": "O.D.S.K",
                        "value": "O.D.S.K"
                    },
                    "date_incident": {
                        "display_value": "18/11/2023",
                        "value": "2023-11-18"
                    },
                    "u_notification_read": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    },
                    "immediate_corrective_action": {
                        "display_value": "Realizado curativo na região sacra.",
                        "value": "Realizado curativo na região sacra."
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "incident_type": {
                        "display_value": "Descumprimento da nr32",
                        "value": "descumprimento_da_nr32"
                    },
                    "involves_patient": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hosp SL - São Caetano do Sul",
                        "value": "235ab5fe1bfa7810bcd687bfe54bcbf8"
                    },
                    "incident_description": {
                        "display_value": "Medica neonatologista Drª Lourdes conversando no celular dentro da sla da UTI Neonatal, na presença dos pais, sobre assuntos particulares.",
                        "value": "Medica neonatologista Drª Lourdes conversando no celular dentro da sla da UTI Neonatal, na presença dos pais, sobre assuntos particulares."
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "18/11/2023 20:29:23",
                        "value": "2023-11-18 23:29:23"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "incident_sector": {
                        "display_value": "UTI - Unidade de Terapia Intensiva / Neonatal",
                        "value": "ea523fd81bc17514739e53111b4bcb1a"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISWHEFHDM4Z6",
                        "value": "HISWHEFHDM4Z6"
                    },
                    "sys_id": {
                        "display_value": "5d3931521b6a3510d83e0dcbe54bcb58",
                        "value": "5d3931521b6a3510d83e0dcbe54bcb58"
                    },
                    "incident_title": {
                        "display_value": "Uso de celular dentro da UTI Neonatal",
                        "value": "Uso de celular dentro da UTI Neonatal"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "18/11/2023 20:29:23",
                        "value": "2023-11-18 23:29:23"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "reporter_sector": {
                        "display_value": "UTI - Unidade de Terapia Intensiva / Neonatal",
                        "value": "ea523fd81bc17514739e53111b4bcb1a"
                    },
                    "shift_incident": {
                        "display_value": "Noturno  (19h - 6h59)",
                        "value": "nighttime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "damage_level.duration_secs": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "18/11/2023",
                        "value": "2023-11-18"
                    },
                    "u_notification_read": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "Desatenção",
                        "value": "Desatenção"
                    },
                    "immediate_corrective_action": {
                        "display_value": "Drª Lourdes é coordenadora e sabe que não pode falar no celular na sala",
                        "value": "Drª Lourdes é coordenadora e sabe que não pode falar no celular na sala"
                    },
                    "mitigating_factors": {
                        "display_value": "Ter saido da sla para falar ao celular",
                        "value": "Ter saido da sla para falar ao celular"
                    }
                },
                {
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "incident_type": {
                        "display_value": "Falha no processo de esterilização/desinfecção/limpeza",
                        "value": "falha_no_processo_de_esterilizacao_desinfeccao_limpeza"
                    },
                    "involves_patient": {
                        "display_value": "Verdadeiro",
                        "value": "true"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hosp SL - São Caetano do Sul",
                        "value": "235ab5fe1bfa7810bcd687bfe54bcbf8"
                    },
                    "incident_description": {
                        "display_value": "Quando solicitado kit AMIU na farmacia, foi observado que não tinha esterilizado, causando atraso na cirurgia, deixando aguardando por mais de 30 minutos.",
                        "value": "Quando solicitado kit AMIU na farmacia, foi observado que não tinha esterilizado, causando atraso na cirurgia, deixando aguardando por mais de 30 minutos."
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "18/11/2023 19:05:24",
                        "value": "2023-11-18 22:05:24"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "20/09/1982",
                        "value": "1982-09-20"
                    },
                    "incident_sector": {
                        "display_value": "Central de Materiais",
                        "value": "7561ff541b0df9909cac32681b4bcb01"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISTSC1PILIAF",
                        "value": "HISTSC1PILIAF"
                    },
                    "sys_id": {
                        "display_value": "87f5a15a1b6af110bcd687bfe54bcb41",
                        "value": "87f5a15a1b6af110bcd687bfe54bcb41"
                    },
                    "incident_title": {
                        "display_value": "Cirurgia de urgencia faltando kit AMIU.",
                        "value": "Cirurgia de urgencia faltando kit AMIU."
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "18/11/2023 19:05:24",
                        "value": "2023-11-18 22:05:24"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "reporter_sector": {
                        "display_value": "Centro Cirúrgico",
                        "value": "f131fb901bc17514739e53111b4bcb9e"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Dano moderado",
                        "value": "cbd08798db76a11083948164049619e2"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": "Atendimento",
                        "value": "atendimento"
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": "Feminino",
                        "value": "feminino"
                    },
                    "damage_level.duration_secs": {
                        "display_value": "432000",
                        "value": "432000"
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "36258415",
                        "value": "36258415"
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "patient_initials": {
                        "display_value": "L.M.B",
                        "value": "L.M.B"
                    },
                    "date_incident": {
                        "display_value": "18/11/2023",
                        "value": "2023-11-18"
                    },
                    "u_notification_read": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "falta de comunicação",
                        "value": "falta de comunicação"
                    },
                    "immediate_corrective_action": {
                        "display_value": "solicitado ao cme esterilizações em caráter de urgência.",
                        "value": "solicitado ao cme esterilizações em caráter de urgência."
                    },
                    "mitigating_factors": {
                        "display_value": "deixar quantidade já estéril ",
                        "value": "deixar quantidade já estéril "
                    }
                },
                {
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "incident_type": {
                        "display_value": "Atraso na entrega medicamento",
                        "value": "atraso_na_entrega_medicamento"
                    },
                    "involves_patient": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "DF - DF Star",
                        "value": "835a75fe1bfa7810bcd687bfe54bcbba"
                    },
                    "incident_description": {
                        "display_value": "Foi prescrito às 16:19 um picoprep e um flagass para o paciente Julio de Oliveira do leito 120, porém, a medicação só pôde ser realizadas às 18:40 (somente foi administrado pois o enfermeiro Nestor foi pessoalmente na farmácia buscar as medicações), devido atrasado absurdo da farmácia, diversas vezes foi entrado em contato com a farmácia e os atendente informaram que a medicação estava no pneumática, ou com o mensageiro ou ainda estava lá, não causou dano ao paciente, mas e se fosse alguma medicação de mais urgência?",
                        "value": "Foi prescrito às 16:19 um picoprep e um flagass para o paciente Julio de Oliveira do leito 120, porém, a medicação só pôde ser realizadas às 18:40 (somente foi administrado pois o enfermeiro Nestor foi pessoalmente na farmácia buscar as medicações), devido atrasado absurdo da farmácia, diversas vezes foi entrado em contato com a farmácia e os atendente informaram que a medicação estava no pneumática, ou com o mensageiro ou ainda estava lá, não causou dano ao paciente, mas e se fosse alguma medicação de mais urgência?"
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "18/11/2023 18:38:26",
                        "value": "2023-11-18 21:38:26"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "incident_sector": {
                        "display_value": "Farmácia",
                        "value": "60e07fd81b81f114d83e0dcbe54bcbff"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISZUYEE4GYU4",
                        "value": "HISZUYEE4GYU4"
                    },
                    "sys_id": {
                        "display_value": "7bcfd5561baeb110739e53111b4bcb32",
                        "value": "7bcfd5561baeb110739e53111b4bcb32"
                    },
                    "incident_title": {
                        "display_value": "Atraso em mais de duas horas ",
                        "value": "Atraso em mais de duas horas "
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "18/11/2023 18:38:26",
                        "value": "2023-11-18 21:38:26"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "reporter_sector": {
                        "display_value": "UTI - D",
                        "value": "416c4e111b1575d0739e53111b4bcbb8"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "damage_level.duration_secs": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "18/11/2023",
                        "value": "2023-11-18"
                    },
                    "u_notification_read": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "Desfalque de funcionários na farmácia (SIC)",
                        "value": "Desfalque de funcionários na farmácia (SIC)"
                    },
                    "immediate_corrective_action": {
                        "display_value": "Administrado medicação com 2:20h de atraso",
                        "value": "Administrado medicação com 2:20h de atraso"
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "incident_type": {
                        "display_value": "Falha/atraso na entrega de insumos",
                        "value": "falha_atraso_na_entrega_de_insumos"
                    },
                    "involves_patient": {
                        "display_value": "Verdadeiro",
                        "value": "true"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hosp SL - São Caetano do Sul",
                        "value": "235ab5fe1bfa7810bcd687bfe54bcbf8"
                    },
                    "incident_description": {
                        "display_value": "SOLICITADO DIETA ENTERAL FRESUBIN HP EM ALMOXARIFADO AS 15:00 .\n18:30 - DIETA NÃO ENTREGUE NO SETOR ",
                        "value": "SOLICITADO DIETA ENTERAL FRESUBIN HP EM ALMOXARIFADO AS 15:00 .\n18:30 - DIETA NÃO ENTREGUE NO SETOR "
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "18/11/2023 18:33:23",
                        "value": "2023-11-18 21:33:23"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "09/08/2023",
                        "value": "2023-08-09"
                    },
                    "incident_sector": {
                        "display_value": "Almoxarifado",
                        "value": "8cf0bfd81b81f114d83e0dcbe54bcbd0"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISNQ1QR8PL3F",
                        "value": "HISNQ1QR8PL3F"
                    },
                    "sys_id": {
                        "display_value": "8aae19121b663510d83e0dcbe54bcb76",
                        "value": "8aae19121b663510d83e0dcbe54bcb76"
                    },
                    "incident_title": {
                        "display_value": "ATRASO EM DIETA ENTERAL.",
                        "value": "ATRASO EM DIETA ENTERAL."
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "18/11/2023 18:33:23",
                        "value": "2023-11-18 21:33:23"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "reporter_sector": {
                        "display_value": "UTI - Unidade de Terapia Intensiva / Adulto",
                        "value": "220237541bc1f114d83e0dcbe54bcb15"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": "Atendimento",
                        "value": "atendimento"
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": "Feminino",
                        "value": "feminino"
                    },
                    "damage_level.duration_secs": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "34706057",
                        "value": "34706057"
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "patient_initials": {
                        "display_value": "L.B",
                        "value": "L.B"
                    },
                    "date_incident": {
                        "display_value": "18/11/2023",
                        "value": "2023-11-18"
                    },
                    "u_notification_read": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": ".",
                        "value": "."
                    },
                    "immediate_corrective_action": {
                        "display_value": ".",
                        "value": "."
                    },
                    "mitigating_factors": {
                        "display_value": ".",
                        "value": "."
                    }
                },
                {
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "incident_type": {
                        "display_value": "Falha na cadeia medicamentosa",
                        "value": "falha_na_cadeia_medicamentosa"
                    },
                    "involves_patient": {
                        "display_value": "Verdadeiro",
                        "value": "true"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "RJ - Clínica São Vicente",
                        "value": "5b5ab5fe1bfa7810bcd687bfe54bcb27"
                    },
                    "incident_description": {
                        "display_value": "Medicamento padronizado Oscal D zerado no almoxarifado, o que gerou o não atendimento do mapa das 16:00 da paciente E.M.D.S (reg.93245). A Farmácia precisou comprar em drogaria para atender à paciente referida.",
                        "value": "Medicamento padronizado Oscal D zerado no almoxarifado, o que gerou o não atendimento do mapa das 16:00 da paciente E.M.D.S (reg.93245). A Farmácia precisou comprar em drogaria para atender à paciente referida."
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "18/11/2023 18:04:23",
                        "value": "2023-11-18 21:04:23"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "24/03/1974",
                        "value": "1974-03-24"
                    },
                    "incident_sector": {
                        "display_value": "Almoxarifado",
                        "value": "8cf0bfd81b81f114d83e0dcbe54bcbd0"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISONJCQNZZFS",
                        "value": "HISONJCQNZZFS"
                    },
                    "sys_id": {
                        "display_value": "810811121beaf9109cac32681b4bcb9f",
                        "value": "810811121beaf9109cac32681b4bcb9f"
                    },
                    "incident_title": {
                        "display_value": "Falta do medicamento Oscal D ",
                        "value": "Falta do medicamento Oscal D "
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "18/11/2023 18:04:23",
                        "value": "2023-11-18 21:04:23"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "reporter_sector": {
                        "display_value": "Farmácia",
                        "value": "60e07fd81b81f114d83e0dcbe54bcbff"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": "Atendimento",
                        "value": "atendimento"
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": "Feminino",
                        "value": "feminino"
                    },
                    "damage_level.duration_secs": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "0093245",
                        "value": "0093245"
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "patient_initials": {
                        "display_value": "E.M.D.S",
                        "value": "E.M.D.S"
                    },
                    "date_incident": {
                        "display_value": "18/11/2023",
                        "value": "2023-11-18"
                    },
                    "u_notification_read": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "Falta de planejamento e controle de estoque.",
                        "value": "Falta de planejamento e controle de estoque."
                    },
                    "immediate_corrective_action": {
                        "display_value": "Compra realizada em farmácia comercial pela farmácia da unidade.",
                        "value": "Compra realizada em farmácia comercial pela farmácia da unidade."
                    },
                    "mitigating_factors": {
                        "display_value": "",
                        "value": ""
                    }
                },
                {
                    "notification_type": {
                        "display_value": "Anônimo",
                        "value": "anonymous"
                    },
                    "incident_type": {
                        "display_value": "Inapropriado/danificado para a função",
                        "value": "inapropriado_danificado_para_a_funcao"
                    },
                    "involves_patient": {
                        "display_value": "Verdadeiro",
                        "value": "true"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "SP - Hosp SL - São Caetano do Sul",
                        "value": "235ab5fe1bfa7810bcd687bfe54bcbf8"
                    },
                    "incident_description": {
                        "display_value": "Recebido paciente de PSI em uso de cateter nasal de O2 \"acoplado\" no nariz, onde o mesmo movimentou-se e estava na região das bochechas (já recebido lactente assim de PSI), encontro cateter nasal cortado (no local onde é acoplado ao nariz), tornando-o insuficiente para uso por não manter-se adequado no rosto. ",
                        "value": "Recebido paciente de PSI em uso de cateter nasal de O2 \"acoplado\" no nariz, onde o mesmo movimentou-se e estava na região das bochechas (já recebido lactente assim de PSI), encontro cateter nasal cortado (no local onde é acoplado ao nariz), tornando-o insuficiente para uso por não manter-se adequado no rosto. "
                    },
                    "reporter_name": {
                        "display_value": "",
                        "value": ""
                    },
                    "sys_updated_on": {
                        "display_value": "18/11/2023 17:30:05",
                        "value": "2023-11-18 20:30:05"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "07/04/2023",
                        "value": "2023-04-07"
                    },
                    "incident_sector": {
                        "display_value": "Pronto Socorro Infantil",
                        "value": "d5a07b5c1b817514739e53111b4bcbc9"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISLUDXYZJAWH",
                        "value": "HISLUDXYZJAWH"
                    },
                    "sys_id": {
                        "display_value": "7220911a1ba23510d83e0dcbe54bcb38",
                        "value": "7220911a1ba23510d83e0dcbe54bcb38"
                    },
                    "incident_title": {
                        "display_value": "Cateter nasal de O2 inapropriado ",
                        "value": "Cateter nasal de O2 inapropriado "
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "18/11/2023 17:30:05",
                        "value": "2023-11-18 20:30:05"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "reporter_sector": {
                        "display_value": "UTI - Unidade de Terapia Intensiva / Pediátrica",
                        "value": "d852f7141bc1f1d0bcd687bfe54bcbf2"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Circunstância notificável",
                        "value": "19d0c798db76a1108394816404961944"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": "Atendimento",
                        "value": "atendimento"
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": "Masculino",
                        "value": "masculino"
                    },
                    "damage_level.duration_secs": {
                        "display_value": "",
                        "value": ""
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "36237061",
                        "value": "36237061"
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "patient_initials": {
                        "display_value": "S.S.M",
                        "value": "S.S.M"
                    },
                    "date_incident": {
                        "display_value": "17/11/2023",
                        "value": "2023-11-17"
                    },
                    "u_notification_read": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "Sem acoplação de cateter nasal, tornando o uso ineficaz podendo causar quedas de SatO2 no paciente. ",
                        "value": "Sem acoplação de cateter nasal, tornando o uso ineficaz podendo causar quedas de SatO2 no paciente. "
                    },
                    "immediate_corrective_action": {
                        "display_value": "Troca de dispositivo de O2.",
                        "value": "Troca de dispositivo de O2."
                    },
                    "mitigating_factors": {
                        "display_value": "Não cortar, ou pelo menos cortar somente as pontas, não a cânula inteira. ",
                        "value": "Não cortar, ou pelo menos cortar somente as pontas, não a cânula inteira. "
                    }
                },
                {
                    "notification_type": {
                        "display_value": "Identificado",
                        "value": "identified"
                    },
                    "incident_type": {
                        "display_value": "Queda do paciente",
                        "value": "queda_do_paciente"
                    },
                    "involves_patient": {
                        "display_value": "Verdadeiro",
                        "value": "true"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "RJ - Clínica São Vicente",
                        "value": "5b5ab5fe1bfa7810bcd687bfe54bcb27"
                    },
                    "incident_description": {
                        "display_value": "PACIENTE COM PULSEIRA AMARELA E ORIENTADA SOBRE OS RISCOS DE QUEDA INSISTE EM DEAMBULAR SEM ACIONAR A ENFERMAGEM OCASIONANDO UMA QUEDA INDO AO BANHEIRO COM A ACOMPANHANTE.",
                        "value": "PACIENTE COM PULSEIRA AMARELA E ORIENTADA SOBRE OS RISCOS DE QUEDA INSISTE EM DEAMBULAR SEM ACIONAR A ENFERMAGEM OCASIONANDO UMA QUEDA INDO AO BANHEIRO COM A ACOMPANHANTE."
                    },
                    "reporter_name": {
                        "display_value": "CAROLINE DE ARAÚJO PACHECO",
                        "value": "CAROLINE DE ARAÚJO PACHECO"
                    },
                    "sys_updated_on": {
                        "display_value": "18/11/2023 17:27:26",
                        "value": "2023-11-18 20:27:26"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "22/01/1960",
                        "value": "1960-01-22"
                    },
                    "incident_sector": {
                        "display_value": "Unid. Internação / Semi-intensiva / TMO",
                        "value": "864524f31ba9f5506adcea8ce54bcb7b"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISUHXYOJGITR",
                        "value": "HISUHXYOJGITR"
                    },
                    "sys_id": {
                        "display_value": "089f89121ba2f110bcd687bfe54bcb5c",
                        "value": "089f89121ba2f110bcd687bfe54bcb5c"
                    },
                    "incident_title": {
                        "display_value": "QUEDA ",
                        "value": "QUEDA "
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "18/11/2023 17:27:26",
                        "value": "2023-11-18 20:27:26"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "reporter_sector": {
                        "display_value": "UTI - Unidade de Terapia Intensiva / Adulto",
                        "value": "220237541bc1f114d83e0dcbe54bcb15"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Sem dano",
                        "value": "62270310dbb6a1108394816404961970"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": "Atendimento",
                        "value": "atendimento"
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": "Feminino",
                        "value": "feminino"
                    },
                    "damage_level.duration_secs": {
                        "display_value": "864000",
                        "value": "864000"
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "0092427",
                        "value": "0092427"
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "patient_initials": {
                        "display_value": "C.M.S.A",
                        "value": "C.M.S.A"
                    },
                    "date_incident": {
                        "display_value": "18/11/2023",
                        "value": "2023-11-18"
                    },
                    "u_notification_read": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "FALTA DE ACIONAMENTO DA ENFERMAGEM",
                        "value": "FALTA DE ACIONAMENTO DA ENFERMAGEM"
                    },
                    "immediate_corrective_action": {
                        "display_value": "REORIENTAÇÃO DA ENFERMEIRA",
                        "value": "REORIENTAÇÃO DA ENFERMEIRA"
                    },
                    "mitigating_factors": {
                        "display_value": "ACIONAR A ENFERMAGEM",
                        "value": "ACIONAR A ENFERMAGEM"
                    }
                },
                {
                    "notification_type": {
                        "display_value": "Identificado",
                        "value": "identified"
                    },
                    "incident_type": {
                        "display_value": "Quase queda do paciente",
                        "value": "quase_queda_do_paciente"
                    },
                    "involves_patient": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_time_closed_by_manager": {
                        "display_value": "",
                        "value": ""
                    },
                    "location_incident": {
                        "display_value": "RJ - Clínica São Vicente",
                        "value": "5b5ab5fe1bfa7810bcd687bfe54bcb27"
                    },
                    "incident_description": {
                        "display_value": "PACIENTE COM PULSEIRA DE QUEDA E ORIENTADA SOBRE OS RISCOS A MESMA INSISTE EM DEAMBULAR COM SUPORTE COM BOMBA PELO QUARTO A MESMA FOI REORIENTADA MAS MESMO ASSIM INSISTE EM NAO DEITAR NO LEITO.",
                        "value": "PACIENTE COM PULSEIRA DE QUEDA E ORIENTADA SOBRE OS RISCOS A MESMA INSISTE EM DEAMBULAR COM SUPORTE COM BOMBA PELO QUARTO A MESMA FOI REORIENTADA MAS MESMO ASSIM INSISTE EM NAO DEITAR NO LEITO."
                    },
                    "reporter_name": {
                        "display_value": "CAROLINE DE ARAÚJO PACHECO",
                        "value": "CAROLINE DE ARAÚJO PACHECO"
                    },
                    "sys_updated_on": {
                        "display_value": "18/11/2023 17:20:56",
                        "value": "2023-11-18 20:20:56"
                    },
                    "u_reclassified_incident_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "patient_date_of_birth": {
                        "display_value": "",
                        "value": ""
                    },
                    "incident_sector": {
                        "display_value": "Unid. Internação / Semi-intensiva / TMO",
                        "value": "864524f31ba9f5506adcea8ce54bcb7b"
                    },
                    "sys_class_name": {
                        "display_value": "Hospital Incidents",
                        "value": "x_rdsls_notificabe_hospital_incidents"
                    },
                    "number": {
                        "display_value": "HISA1FEH0BBXM",
                        "value": "HISA1FEH0BBXM"
                    },
                    "sys_id": {
                        "display_value": "f81e05d21ba23510d83e0dcbe54bcbf3",
                        "value": "f81e05d21ba23510d83e0dcbe54bcbf3"
                    },
                    "incident_title": {
                        "display_value": "Quase queda",
                        "value": "Quase queda"
                    },
                    "sys_updated_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "sys_created_on": {
                        "display_value": "18/11/2023 17:20:56",
                        "value": "2023-11-18 20:20:56"
                    },
                    "u_oms_classification": {
                        "display_value": null,
                        "value": ""
                    },
                    "reporter_sector": {
                        "display_value": "UTI - Unidade de Terapia Intensiva / Adulto",
                        "value": "220237541bc1f114d83e0dcbe54bcb15"
                    },
                    "shift_incident": {
                        "display_value": "Diurno (7h - 18h59)",
                        "value": "daytime"
                    },
                    "sys_created_by": {
                        "display_value": "notifica.admin",
                        "value": "notifica.admin"
                    },
                    "damage_level": {
                        "display_value": "Sem dano",
                        "value": "62270310dbb6a1108394816404961970"
                    },
                    "u_sub_damage_level": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_type": {
                        "display_value": null,
                        "value": ""
                    },
                    "u_treatment_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_assigned_to": {
                        "display_value": "",
                        "value": ""
                    },
                    "patient_gender": {
                        "display_value": null,
                        "value": ""
                    },
                    "damage_level.duration_secs": {
                        "display_value": "864000",
                        "value": "864000"
                    },
                    "forwarded_by": {
                        "display_value": "",
                        "value": ""
                    },
                    "document_number": {
                        "display_value": "",
                        "value": ""
                    },
                    "u_state": {
                        "display_value": "Nova",
                        "value": "1"
                    },
                    "sys_mod_count": {
                        "display_value": "0",
                        "value": "0"
                    },
                    "patient_initials": {
                        "display_value": "",
                        "value": ""
                    },
                    "date_incident": {
                        "display_value": "18/11/2023",
                        "value": "2023-11-18"
                    },
                    "u_notification_read": {
                        "display_value": "Falso",
                        "value": "false"
                    },
                    "u_date_and_hour_notification_closed": {
                        "display_value": "",
                        "value": ""
                    },
                    "contributing_mitigating_factors": {
                        "display_value": "DEAMBULANDO COM SUPORTE DE BOMBA E IDADE AVANÇADA",
                        "value": "DEAMBULANDO COM SUPORTE DE BOMBA E IDADE AVANÇADA"
                    },
                    "immediate_corrective_action": {
                        "display_value": "REORIENTAÇÃO DA ENFERMEIRA",
                        "value": "REORIENTAÇÃO DA ENFERMEIRA"
                    },
                    "mitigating_factors": {
                        "display_value": "RESTRITAÇÃO AO LEITO",
                        "value": "RESTRITAÇÃO AO LEITO"
                    }
                }
            ]
        }
    }
]